import React from 'react';
import {connect} from 'react-redux'
import {Route, Switch, withRouter} from 'react-router-dom'
import {bindActionCreators} from 'redux'

import {clearAlert, clearState} from 'Skelet/src/modules/fetch.action.js'
import AlertBar from 'Skelet/src/components/AlertBar.js'
import Start from './Start.js'
import Terms from './Terms.js'
import Privacy from './Privacy.js'
import PageNotFound from 'Skelet/src/components/PageNotFound.js'
import StartRoute from './route-containers/StartRoute.js'


class App extends React.Component {

  render() {
    return (
      <div id="main">
        <Switch>
          <StartRoute exact path="/" component={Start} />

          <StartRoute exact path="/terms" component={Terms} />

          <StartRoute exact path="/privacy" component={Privacy} />

          <Route path="*" component={PageNotFound} />
        </Switch>
        <AlertBar alert={this.props.alert} clearAlert={this.props.clearAlert} />
      </div>
    );
  }

}


function mapStateToProps(state) {
  return {
    alert: state.apiData.alert,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    clearAlert,
    clearState,
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App))



// WEBPACK FOOTER //
// ./src/containers/_app.js